import React from 'react';
import { Tooltip as TooltipDS } from '@lmn/design-system';

type TooltipProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  label: React.ReactElement<any> | string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: React.ReactElement<any>;
  open?: boolean;
  title?: string;
  placement?: 'left' | 'right' | 'top' | 'bottom';
  maxWidth?: number;
  className?: string;
};

export default function Tooltip(props: TooltipProps) {
  const { children, className, label, ...rest } = props;

  return (
    <TooltipDS {...rest} content={label}>
      <div className={className}>{children}</div>
    </TooltipDS>
  );
}
